/** @format */

import {TanStackTableData} from 'components/Table/core/types';

import {safeDivide, roundFloatNumber} from 'helpers/numberHelpers';

const MEDIAPLAN_TYPE_LABELS: Record<string, string> = {
  perform: 'За клики',
  media: 'За показы',
};

interface CampaignStatFromQuery {
  readonly campaignId: string;
  readonly campaignName: string;
  readonly accountId: string;
  readonly accountName: string;
  readonly mediaplanType: string;
  readonly spent: number;
  readonly clicks: number;
  readonly impressions: number;
  readonly conversions: number;
  readonly ePurchaseConversions: number;
  readonly revenue: number;
}

interface MapCampaignStatisticsOptions {
  data: ReadonlyArray<CampaignStatFromQuery>;
  mediaplanType?: string | null;
}

const mapCampaignStatistics = ({
  data,
  mediaplanType,
}: MapCampaignStatisticsOptions): TanStackTableData[] => {
  return data
    .filter(stats => {
      if (!mediaplanType) return true;
      return stats.mediaplanType.toLowerCase() === mediaplanType.toLowerCase();
    })
    .map(stats => {
      const spent = roundFloatNumber(stats.spent, 0);

      const ctrFloat = safeDivide(stats.clicks, stats.impressions) * 100;
      const ctr = roundFloatNumber(ctrFloat, 1);

      const cpcFloat = safeDivide(stats.spent, stats.clicks);
      const cpc = roundFloatNumber(cpcFloat, 0);

      const cplFloat = safeDivide(stats.spent, stats.conversions);
      const cpl = roundFloatNumber(cplFloat, 0);

      const drrFloat = safeDivide(stats.spent, stats.revenue) * 100;
      const drr = roundFloatNumber(drrFloat, 1);

      return {
        title: stats.campaignName,
        id: stats.campaignId,
        subAccount: stats.accountName,
        mediaplanType:
          MEDIAPLAN_TYPE_LABELS[stats.mediaplanType.toLowerCase()] || stats.mediaplanType,
        spent,
        impressions: stats.impressions,
        clicks: stats.clicks,
        ctr,
        cpc,
        conversions: stats.conversions,
        cpl,
        ePurchaseConversions: stats.ePurchaseConversions,
        revenue: stats.revenue,
        drr,
      } as TanStackTableData;
    });
};

export {mapCampaignStatistics};
export type {CampaignStatFromQuery, MapCampaignStatisticsOptions};
